import React from 'react'

export default function Header() {
    return (
        <div id="my_title">
            <h1>SWAPI</h1>
            <h3>The Star Wars API</h3>
        </div>
    )
}
